/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { Link } from '@lmig/lmds-react';

const {
  publicRuntimeConfig: {
    smsApi = {},
  },
} = getConfig();

const { url = "", phoneNumber = "" } = smsApi;

const TextPhoneNumber = ({
  useCase = 'dot_com_support'
}) => {
  const textApiUrl = `${url}?usecase=${useCase}`;

  return <Link href={textApiUrl}>{phoneNumber}</Link>;
};

TextPhoneNumber.propTypes = {
  useCase: PropTypes.string,
};

export default TextPhoneNumber;
